import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { Layout } from '../components/Layout';
const SERVICES = [{
  title: 'Kitchen',
  description: 'Our services include furniture quality kitchen or bath cabinetry with more than 500,000 combinations of door styles, wood species and finishes to Texas made unfinished custom cabinets at affordable prices.',
  image: 'https://images.unsplash.com/photo-1556912173-3bb406ef7e77?auto=format&fit=crop&q=80&w=800',
  link: '/showroom'
}, {
  title: 'Bathroom',
  description: 'Transform your bathroom into a personal sanctuary with our custom vanities and premium storage solutions. We offer moisture-resistant finishes and high-end hardware designed for longevity.',
  image: 'https://cdn.magicpatterns.com/uploads/aj82HdUgjrEekn9C99Y12s/home-img-1.png',
  link: '/showroom'
}, {
  title: 'Flooring',
  description: 'Complete your home transformation with our wide variety of brand name flooring options. From classic hardwood to modern luxury vinyl, we provide expert installation for both residential and commercial needs.',
  image: 'https://cdn.magicpatterns.com/uploads/szDXp6VuaBmHm96ZSTfwkT/image.png',
  link: '/showroom'
}];
export function ProcessPage() {
  return <Layout data-id="element-436">
      {/* Hero Section */}
      <section className="relative h-[40vh] md:h-[50vh] flex items-center justify-center overflow-hidden" data-id="element-437">
        <div className="absolute inset-0 z-0" data-id="element-438">
          <img src="https://cdn.magicpatterns.com/uploads/6aeoEk3h4SjXfmdMFG8etV/image.png" alt="Our Services Background" className="w-full h-full object-cover brightness-[0.5]" data-id="element-439" />
          <div className="absolute inset-0 bg-black/20" data-id="element-440" />
        </div>

        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="relative z-10 text-4xl md:text-6xl font-bold text-white uppercase tracking-tighter text-center" data-id="element-441">
          Our Services
        </motion.h1>
      </section>

      {/* Intro Text */}
      <section className="py-12 px-6 bg-white" data-id="element-442">
        <div className="max-w-4xl mx-auto text-center" data-id="element-443">
          <p className="text-xl md:text-2xl text-charcoal font-bold leading-tight" data-id="element-444">
            Premium workmanship. Real wood quality. <br data-id="element-445" />
            <span className="text-[#6B0D24]" data-id="element-446">No particle board. Ever.</span>
          </p>
        </div>
      </section>

      {/* Services List */}
      <section className="pb-16 px-6 bg-white" data-id="element-447">
        <div className="max-w-7xl mx-auto space-y-16" data-id="element-448">
          {SERVICES.map((service, idx) => <motion.div key={service.title} initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.8,
          ease: [0.22, 1, 0.36, 1]
        }} className={`flex flex-col lg:flex-row items-center gap-10 lg:gap-16 ${idx % 2 !== 0 ? 'lg:flex-row-reverse' : ''}`} data-id="element-449">
              <div className="flex-1 w-full aspect-[4/3] overflow-hidden border border-charcoal/5 shadow-2xl" data-id="element-450">
                <img src={service.image} alt={service.title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-1000" data-id="element-451" />
              </div>

              <div className="flex-1 space-y-8" data-id="element-452">
                <h2 className="text-4xl md:text-5xl font-black text-[#6B0D24] uppercase tracking-tight" data-id="element-453">
                  {service.title}
                </h2>
                <p className="text-lg text-charcoal/60 leading-relaxed max-w-xl" data-id="element-454">
                  {service.description}
                </p>
                <Link to={service.link} className="inline-block bg-[#6B0D24] text-white px-10 py-4 font-black uppercase tracking-widest text-xs hover:bg-[#5A0B1E] transition-colors" data-id="element-455">
                  Read More
                </Link>
              </div>
            </motion.div>)}
        </div>
      </section>
    </Layout>;
}